export const shallowStrings = {
  call: "Call: ",
  callNow: "Call now: ",
  callUsNow: "Call us now: ",
  getStarted: "Get Started",
  openCallUsNow: "We're open! Call us now: ",
};
